export default "/static/dashboard/build/app/img/v2/6a96747bd180fac7eea3e712636613e7.png";